/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

@import '@spectrum/spectrum-variables/stylus/spectrum-light.styl'

:local(.root)
  height 100%
  width 100%
  display flex
  flex-direction column
  position relative

:local(.content)
  display flex
  width 100%
  flex-grow 5
  max-height calc(100% - 60px)
  margin-top 12px

:local(.contentChild)
  display flex
  height 100%
  flex-direction column
  max-height calc(100%)
  margin-right 40px

:local(.listBox)
  overflow-y scroll
  overflow-x hidden
  flex-grow 5
  padding 0 8px
  border solid 1px $spectrum-alias-dropshadow-color

:local(.useOrg)
  position absolute
  top 10px
  left 250px

:local(.noViewPlugins)
  :local(.useOrg)
    top 80px
    left 20px

:local(.redIcon)
  color $spectrum-global-color-red700
